<button
  mat-icon-button
  type="button"
  [matMenuTriggerFor]="notificationMenu"
  (menuOpened)="onMenuOpened()"
  [matBadge]="unreadCount()"
  [matBadgeHidden]="unreadCount() === 0"
  matBadgeColor="warn"
  matBadgeSize="small"
  matBadgeOverlap="true"
  [attr.aria-label]="'알림' + (unreadCount() > 0 ? ' — 안읽음 ' + unreadCount() + '건' : '')"
>
  <mat-icon>notifications</mat-icon>
</button>

<mat-menu #notificationMenu="matMenu" xPosition="before" class="nb__panel">
  <div class="nb__header" (click)="$event.stopPropagation()">
    <span class="nb__title">알림</span>
    <button mat-button type="button" [disabled]="unreadCount() === 0" (click)="markAllRead()">
      모두 읽음
    </button>
  </div>

  @if (loading()) {
    <div class="nb__state">
      <mat-progress-spinner mode="indeterminate" diameter="28" />
    </div>
  } @else if (!loadedOnce() || items().length === 0) {
    <div class="nb__state">새 알림이 없습니다</div>
  } @else {
    @for (item of items(); track item.id) {
      <button
        mat-menu-item
        type="button"
        class="nb__item"
        [class.nb__item--unread]="!item.readAt"
        (click)="onItemClick(item)"
      >
        <mat-icon [class]="'nb__item-icon nb__item-icon--' + item.level">{{ levelIcon(item.level) }}</mat-icon>
        <span class="nb__item-body">
          <span class="nb__item-title">{{ item.title }}</span>
          <span class="nb__item-time">{{ relativeTime(item.createdAt) }}</span>
        </span>
        @if (!item.readAt) {
          <span class="nb__item-dot" aria-hidden="true"></span>
        }
      </button>
    }
  }

  @if (viewAllRoute(); as route) {
    <a mat-menu-item [routerLink]="route">전체 보기</a>
  }
</mat-menu>
